<template>
	<transition name="run">
		<div v-if="isShow" class="page-first page-home page-generate" :style="'height: '+height+'px'">
			<div class="generate-content" :style="cStyle">
				<div class="generate-ani generate-ani-sun" :class="'a'+earthNum" :style="'height: '+height+'px'"></div>
				<div class="generate-heart-animate"></div>
			</div>
			<div class="generate-progress">
				<div class="generate-loading-text">
					<p>{{ loadingText[loadingIndex] }}</p>
				</div>
				<div class="generate-loading-box">
					<div class="generate-loading-bar-box">
						<div class="generate-loading-bar" :style="'width: '+loadingNum+'%'">
							<span v-for="i in 30" class="bar-item"></span>
						</div>
					</div>
				</div>
				<div class="generate-loading-percent">{{ loadingNum+'%' }}</div>
			</div>
		</div>
	</transition>
</template>

<script>
import * as doctitle from '../../modules/data/base/doctitle'
import { DOM } from '../../modules/dom';
export default {
	name: "MarriageGenerate",
	components: {  },
	computed: {
		userInfo() {
			return this.fromPage == 'strong' ? this.$store.state.user.strongUserInfo : this.$store.state.detail.personInfo;
		},
		marriageData() {
            return this.$store.state.marriage.marriageData;
        },
	},
	data() {
		return {
			isShow: true,
			fromPage: '',
			height: 720,
			manTime: 80, manNum: 1,
			earthTime: 120, earthNum: 1,
			cStyle: '',
			loadingText: [
				'正在计算生成个人姻缘综合得分……',
				'正在计算生成主人生日能量评测……',
				'正在计算生成婚姻观……',
				'正在计算生成夫妻星的稳定性……',
				'正在计算生成夫妻宫的稳定性……',
				'正在计算生成夫妻宫与工作和谐度……',
				'正在计算生成桃花出现的时间预测……',
				'正在计算生成未来配偶的画像……',
				'正在计算生成结婚生子的时间预测……',
			],
			loadingText2: [
                '正在计算生成二人缘分综合得分……',
                '正在计算生成双方生日能量评测……',
                '正在计算生成各自的婚姻观……',
                '正在计算生成各自夫妻星的稳定性……',
                '正在计算生成各自夫妻宫的稳定性……',
                '正在计算生成相处方式和谐度……',
                '正在计算生成夫妻宫的匹配度……',
                '正在计算生成整体生日能量契合度……',
                '正在计算生成月老送上天长地久建议……',
            ],
			loadingIndex: 0,
			loadingFunc: undefined,
			loadingNum: 0,
			curParams: {},
		}
	},
	mounted() {
		setTimeout(function() {
			this.height = innerHeight;
			if(!this.marriageData.id) {
				this.$router.replace({ path: '/marriagerecord' });
				return;
			}
			if(this.marriageData && this.marriageData.f_type == 2) {
				this.loadingText = this.loadingText2;
			}
			this.initDom();
			this.initAnimation();
			this.initLoading();
		}.bind(this), 20);
	},
	methods: {
		initDom() {
			this.$el.style.height = window.screen.height+'px';
			var scaleX = parseFloat(innerWidth/750), 
				scaleY = parseFloat(window.screen.height/1334);
			var cLeft = innerWidth-750, 
				cTop = window.screen.height >= 800 ? scaleY*window.screen.height-window.screen.height-20 : (window.screen.height-1334)/2;
			// console.error('generate------', cLeft, cTop, innerWidth, window.screen.height)
			var scaleValue = scaleX > scaleY ? scaleY : scaleX;
			this.cStyle = this.cStyle+ 'transform: scale('+scaleValue+','+scaleValue+'); left: '+cLeft/2+'px; top: '+cTop+'px';
		},
		initAnimation() {
			var me = this;
			function ani1() {
				me.manNum = me.manNum == 16 ? 1 : me.manNum+1;
				setTimeout(ani1, me.manTime)
			}
			ani1();
			
			function ani2() {
				me.earthNum = me.earthNum == 16 ? 1 : me.earthNum+1;
				setTimeout(ani2, me.earthTime)
			}
			ani2();
		},
		initLoading() {
			var me = this, speed = 50; //50
            function runLoad() {
                // console.error('runLoad-----', me.timeStr)
				me.loadingIndex = parseInt(me.loadingNum/10)-1;
				me.loadingIndex = me.loadingIndex < 0 ? 0 : me.loadingIndex;
				me.loadingIndex = me.loadingIndex >= (me.loadingText.length-1) ? me.loadingText.length-1 : me.loadingIndex;
				if(me.loadingNum < 100) {
					var randNum =  Math.floor(Math.random() * 3) + 1;
					var randTime = (Math.floor(Math.random() * 10) + 1)*speed;
                    me.loadingNum += randNum;
					me.loadingNum = me.loadingNum > 100 ? 100 : me.loadingNum;
                    me.loadingFunc = setTimeout(() => {
                        runLoad();
                    }, randTime);
				}else if(me.loadingNum >= 100) {
					clearTimeout(me.loadingFunc);
					me.isShow = false;
					me.gotoPage();
				}
            }
            runLoad();
		},
		gotoPage() {
			console.log('gotoPage-----', this.marriageData);
			if(this.marriageData && this.marriageData.id) {
				this.$store.dispatch('marriage/getMarriageFavorableInfoById', {
                    rData: this.marriageData,
                    sucCb: ()=> {
						if(this.marriageData.f_type == 1) {
							this.$router.replace({ path: '/marriagereportone/'+this.marriageData.id });
						}else if(this.marriageData.f_type == 2) {
							this.$router.replace({ path: '/marriagereporttwo/'+this.marriageData.id });
						}
                    }
                })
			}else {
				this.$router.replace({ path: '/marriage' });
			}
		},
	}
}
</script>

<style lang="scss" scoped>
    .run-leave-active {
        animation: generateZoom 0.5s linear;
    }
	@keyframes generateZoom {
	0%{
		transform: scale(1);
		opacity: 1;
	}
	40% {
		transform: scale(2);
		opacity: 0.5;
	}
	100% {
		transform: scale(3);
		opacity: 0;
	}
}
</style>